import * as Yup from "yup";

export const FormQualitySealSchema = () => {
  return Yup.object().shape({
    fecha: Yup.string()
      .required("La fecha es requerida")
      .trim(),

    foliosDel: Yup.number()
      .typeError("El folio inicial debe ser un número")
      .integer("Debe ser entero")
      .required("El folio inicial es requerido"),

    al: Yup.number()
      .typeError("El folio final debe ser un número")
      .integer("Debe ser entero")
      .required("El folio final es requerido")
      .test("al>=foliosDel", "El folio final no puede ser menor al folio inicial", function (value) {
        const { foliosDel } = this.parent;
        const del = parseInt(String(foliosDel ?? ""), 10);
        const al = parseInt(String(value ?? ""), 10);
        if (!Number.isFinite(del) || !Number.isFinite(al)) return true; // Yup ya marca required/typeError
        return al >= del;
      }),

    maquina: Yup.string()
      .required("La máquina es requerida")
      .trim(),

    noOT: Yup.string()
      .required("El No. O.T. es requerido")
      .trim(),

    cliente: Yup.string()
      .required("El cliente es requerido")
      .trim(),

    logotipo: Yup.string()
      .required("El logotipo es requerido")
      .trim(),

    proceso: Yup.string()
      .trim()
      .oneOf(
        [
          "ULTRASONIDO",
          "PLASMA",
          "IMPRESION",
          "Hot stamping",
          "Transfer",
          "Laser",
          "Ink Jet",
          "OTRO", // ✅ AGREGAR ESTO
        ],
        "Proceso inválido"
      )
      .min(1, "El proceso es requerido")
      .required("El proceso es requerido"),

    procesoOtro: Yup.string().when("proceso", {
      is: "OTRO",
      then: (schema) => schema.required("Especifica el proceso"),
      otherwise: (schema) => schema.notRequired(),
    }),

    turno: Yup.string()
      .trim()
      .oneOf(["1er", "2do"], "Turno inválido")
      .min(1, "El turno es requerido")
      .required("El turno es requerido"),

    tipoFolio: Yup.string().required("Selecciona el tipo de folio"),

    horaInicio: Yup.string()
      .required("La hora de inicio es requerida")
      .trim(),

    horaTermino: Yup.string()
      .required("La hora de término es requerida")
      .trim(),

    totalEntregadas: Yup.number()
      .typeError("Total entregadas debe ser un número")
      .integer("Debe ser entero")
      .min(0, "No puede ser negativo")
      .required("El total de piezas entregadas es requerido"),

    modelo: Yup.string()
      .required("El modelo es requerido")
      .trim(),

    longitud: Yup.string()
      .required("La longitud es requerida")
      .trim(),

    color: Yup.string()
      .required("El color es requerido")
      .trim(),

    mermasDefecto: Yup.number()
      .required("La merma es requerida, sino hay agrega n/a")
      .typeError("Mermas por defecto debe ser un número")
      .integer("Debe ser entero")
      .min(0, "No puede ser negativo")
      .nullable(),

    mermasErrorHumano: Yup.number()
      .required("La merma es requerida, sino hay agrega n/a")
      .typeError("Mermas por error humano debe ser un número")
      .integer("Debe ser entero")
      .min(0, "No puede ser negativo")
      .nullable(),

    mermasRecupera: Yup.number()
      .required("La merma es requerida, sino hay agrega n/a")
      .typeError("Mermas recuperables debe ser un número")
      .integer("Debe ser entero")
      .min(0, "No puede ser negativo")
      .nullable(),

    pruebasCalidad: Yup.number()
      .required("La merma es requerida, sino hay agrega n/a")
      .typeError("Pruebas de calidad debe ser un número")
      .integer("Debe ser entero")
      .min(0, "No puede ser negativo")
      .nullable(),

    observaciones: Yup.string()
      .required("Las observaciones son requeridas")
      .trim()
      .max(1000, "Máximo 1000 caracteres"),
  });
};